export default "dist/assets/images/patty.54595a9ff1e789fe24c55b4f4bd1dec8.svg";